import { render, staticRenderFns } from "./myComplaints.vue?vue&type=template&id=004296bc&scoped=true&"
import script from "./myComplaints.vue?vue&type=script&lang=js&"
export * from "./myComplaints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004296bc",
  null
  
)

export default component.exports